const counselorsData = [
    {
      id: 1,
      name: 'Dr. Jane Doe',
      specialty: 'Trauma Specialist',
      experience: '10 years',
      image: 'https://cdn.pixabay.com/photo/2017/09/06/20/36/doctor-2722941_1280.jpg',
    },
    {
      id: 2,
      name: 'Mr. John Smith',
      specialty: 'Anxiety & Depression',
      experience: '8 years',
      image: 'https://media.istockphoto.com/id/1358954903/photo/shot-of-a-mature-doctor-standing-alone-in-his-clinic-with-his-arms-folded.jpg?s=612x612&w=0&k=20&c=yzdvK4p6E3QVKy0gSnGogqlkSqXwGKQHEVO5Du310JU=',
    },
    {
      id: 3,
      name: 'Ms. Emma Johnson',
      specialty: 'Grief Counseling',
      experience: '6 years',
      image: 'https://media.istockphoto.com/id/1471886621/photo/young-adult-woman-gestures-and-talks-during-interview-with-businesswoman.jpg?s=612x612&w=0&k=20&c=57hyY3qxneb2MzzXnjpYzasqJWuPpaTVm92Kgf5bGgQ=',
    },
    {
      id: 4,
      name: 'Dr. Chris Evans',
      specialty: 'Family & Couples Therapy',
      experience: '15 years',
      image: 'https://media.istockphoto.com/id/2035526310/photo/portrait-of-young-successful-hispanic-doctor-inside-clinic-man-smiling-and-looking-at-camera.jpg?s=612x612&w=0&k=20&c=XqngRSGkBzuHT9w56UQNiXy1FEMp_UpOLDXVoERJSQc=',
    },
  ];

  export default counselorsData;